import { createSelector } from '@reduxjs/toolkit';
import { createSelector as createSelectorReselect } from 'reselect';
import { filterDynamicLayers as filterNegativeDynamicLayers } from '../utils/spatialLayersHelpers';
import { SOURCE_CRG } from './spatialLayersSources';

export const filteredDynamicLayers = (
  dynamicLayers = [],
  disabledDynamicLayers = [],
) => {
  return dynamicLayers.filter(
    layer => disabledDynamicLayers?.indexOf(layer.key) === -1,
  );
};

// TODO: switch from using `createSelector from `reselect` to using RTK's version for one less dependency

export const allSpatialLayersSelector = createSelectorReselect(
  spatialLayers => spatialLayers,
  spatialLayers => {
    const dynamicLayers = [
      ...filterNegativeDynamicLayers(spatialLayers.dynamicLayers),
    ];
    const disabledDynamicLayers = spatialLayers.disabledDynamicLayers;
    return [
      ...spatialLayers.staticLayers,
      ...filteredDynamicLayers(dynamicLayers, disabledDynamicLayers),
    ];
  },
);

/**
 * Find the spatial layer that a spatial object belongs to based on the spatial object's external_id
 */
export const parentSpatialLayerSelector = createSelectorReselect(
  spatialLayers => spatialLayers,
  spatialLayers => {
    const currentExternalID =
      spatialLayers.activeCrgObject.spatialObject.external_id;
    return spatialLayers.staticLayers.find(staticLayer =>
      staticLayer.spatial_objects.find(
        spatialObject => spatialObject.external_id === currentExternalID,
      ),
    );
  },
);

/**
 * Get all CRG spatial layers by `source`. While it's possible for there to be
 * multiple, we expect one in production
 * @param {Array} staticLayers - spatialLayers.staticLayers state
 */
export const CRGSpatialLayerSelector = createSelector(
  staticLayers => staticLayers,
  staticLayers => {
    return staticLayers.filter(
      staticLayer => staticLayer.source === SOURCE_CRG,
    );
  },
);

/**
 * Get all NON-CRG spatial layers by `source`.
 * @param {Array} staticLayers - spatialLayers.staticLayers state
 */
export const baseSpatialLayerSelector = createSelector(
  staticLayers => staticLayers,
  staticLayers => {
    return staticLayers.filter(
      staticLayer => staticLayer.source !== SOURCE_CRG,
    );
  },
);
